import { AutomationTrigger } from 'hocs/automations/api/types';
export const FORM_NAME = 'createAutomationForm';
const MAX_LENGTH = 255;
export const validateEditFormStep1 = (values) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Required';
    }
    else if (values.name.trim().length <= 1) {
        errors.name = 'Must be 2 characters or more';
    }
    else if (values.name.trim().length > MAX_LENGTH) {
        errors.name = `Must be less then ${MAX_LENGTH} characters`;
    }
    return errors;
};
export const validateEditFormStep2 = (values) => {
    const errors = {};
    if (values.channels.length === 0) {
        errors.channels = 'Required';
    }
    if (!values.trigger) {
        errors.trigger = 'Required';
    }
    else if (values.trigger === AutomationTrigger.NONE) {
        errors.trigger = 'Required';
    }
    return errors;
};
